const getters = {
  getConfigObject: (state) => state.configObject,
  getSelectedConfig: (state) => state.selectedConfigurations,
  getLoadingStatus: (state) => state.loading,
  getIsGenerating: (state) => state.isGenerating,
  getIsResponding: (state) => state.isResponding,
  getIsTypingEffect: (state) => state.isTypingEffect,
  getConversation: (state) => state.conversationHistory,
  getIndicators: (state) => ((state.controlConfig && state.controlConfig[0] && state.controlConfig[0].setup && state.controlConfig[0].setup[0]) ? state.controlConfig[0].setup[0].options : []),
  getControlConfig: (state) => ((state.controlConfig && state.controlConfig[0]) ? state.controlConfig[0].payload : null),
  getSelectedSection: (state) => state.selectedSection,
  getCustomDashboards: (state) => state.dashboards,
  getIDCDatasources: (state) => ((state.controlConfig && state.controlConfig[2] && state.controlConfig[2].setup && state.controlConfig[2].setup[1]) ? state.controlConfig[2].setup[1].options : []),
  getFunFact: (state) => state.funFact,
};

export default getters;
